import React from 'react';
import Image from '../images/job-interview6.jpg';
import SectionHead from './SectionHead';
import { GiCutDiamond } from 'react-icons/gi';
import { values } from '../data';
import Card from '../UI/Card';
import { Link } from 'react-router-dom'; // Import Link for navigation
import { AiFillCaretRight } from 'react-icons/ai'; // Import the caret right icon
import '../pages/home/home.css';

const Values = () => {
    return (
        <section className='values'>
            <div className="values__container">
                <div className="values__left">
                    <div className="values__image">
                        <img src={Image} alt="Job Interview" />
                    </div>
                </div>
                <div className="values__right">
                    <SectionHead icon={<GiCutDiamond />} title="Pre-screening" />
                    <p>
                        Explore a treasure trove of insightful interviews. Welcome to our video library, where past conversations come to life.
                    </p>
                    <div className="values__wrapper">
                        {
                            values.map(({ id, icon, title, desc, path }) => (
                                <Card key={id} className="values__value"> 
                                    <span>{icon}</span>
                                    <h4>{title}</h4>
                                    <small>{desc}</small>
                                    <Link to={path} className="btn sm"> 
                                        Watch here <AiFillCaretRight />
                                    </Link>
                                </Card>
                            ))
                        }
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Values;
